import { Injectable } from '@angular/core';
import { AbstractRecommendationService, Content, LocalizedData } from 'osn-shared';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MockRecommendationService extends AbstractRecommendationService {
  public getRecommendationTrayContent$(
    recommendationQuery: Record<string, string>
  ): Observable<{ preview: Array<Content>; titleLocalized: LocalizedData<string> }> {
    return of({ preview: [], titleLocalized: undefined });
  }

  public getRecommendedContentPreviews$(guid: string): Observable<Content[]> {
    return of([]);
  }
}
